import { useRoomContext } from "@livekit/components-react";

export const useLivekitLeaveRoom = () => {
  const room = useRoomContext();

  return () => room.disconnect();
};
